import React from "react";
import { Plus, UserPlus, Zap } from "react-feather";
import { CardStack } from "../../molecules/CardStack";
import { NavDrawer } from "../../molecules/NavDrawer";
import { PRIMARY_NAV_DRAWER_COPY as COPY } from "./PrimaryNavDrawer.copy";
import { Account, CreateButton } from "./PrimaryNavDrawer.styles";
import type { PrimaryNavDrawerProps } from "./PrimaryNavDrawer.types";

const Sparkle: React.FC<{ size?: number | string }> = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 2l2 6.5L20.5 10 14 12l-2 6.5L10 12 3.5 10 10 8.5z" />
  </svg>
);

/** The app's primary navigation as an overlay drawer, with the promo stack, create button and account. */
export const PrimaryNavDrawer: React.FC<PrimaryNavDrawerProps> = ({
  open,
  onClose,
  items,
  pathname,
  onCreate,
  onInvite,
  onConnect,
  profile,
  variant = "modal",
  docked = false,
  onPinToggle,
  onPointerEnter,
  onPointerLeave,
}) => {
  const toItem = ({ id, to, label, icon, soon, isSelected }: PrimaryNavDrawerProps["items"][number]) => ({
    id,
    to,
    label,
    icon,
    soon,
    selected: isSelected(pathname),
  });
  const main = items.filter((item) => item.section !== "manage").map(toItem);
  const manage = items.filter((item) => item.section === "manage").map(toItem);
  return (
    <NavDrawer
      open={open}
      onClose={onClose}
      label={COPY.label}
      soonLabel={COPY.soon}
      variant={variant}
      docked={docked}
      onPinToggle={onPinToggle}
      pinLabel={docked ? COPY.unpin : COPY.pin}
      onPointerEnter={onPointerEnter}
      onPointerLeave={onPointerLeave}
      sections={[
        { id: "main", items: main },
        ...(manage.length ? [{ id: "manage", items: manage }] : []),
      ]}
      footer={
        <>
          <CardStack
            label={COPY.stackLabel}
            soonLabel={COPY.soon}
            cards={[
              // PENDING: PENDING-EXTENSION
              { id: "capture", ...COPY.capture, icon: Sparkle, soon: true },
              { id: "invite", ...COPY.invite, icon: UserPlus, accent: "info", onSelect: onInvite },
              { id: "connect", ...COPY.connect, icon: Zap, accent: "warning", onSelect: onConnect },
            ]}
          />
          <CreateButton
            type="button"
            onClick={() => {
              onClose();
              onCreate();
            }}
          >
            <Plus size={16} aria-hidden="true" />
            {COPY.create}
          </CreateButton>
          {profile ? <Account>{profile}</Account> : null}
        </>
      }
    />
  );
};

export default PrimaryNavDrawer;
